

































import Vue from 'vue';
import Component from 'vue-class-component';
import moment from 'moment-timezone';
import { Breakpoint } from 'vuetify/types/services/breakpoint';
import ProfileAvatar from '@/components/Profile/ProfileAvatar.vue';
import { authModule, publicProfileModule, userModule, userState } from '@/utils/store-acessor';
import { UserModel } from '@/models/user.model';

@Component({
  components: {
    ProfileAvatar
  }
})
export default class ProfileHeader extends Vue {
  @publicProfileModule.Getter('publicProfile')
  publicProfile!: UserModel;
  @userModule.Getter('user') user!: UserModel;
  @authModule.Getter('isAuthenticated') isAuthenticated!: boolean;
  @userModule.Getter('timezone') timezone!: string;

  isPublic: boolean = false;

  mounted() {
    this.isPublic = !(this.$route.params.slug === 'me' || this.$route.path === '/profile/config');
    if (this.isAuthenticated) {
      userState.fetchUser();
    }
  }

  get fullname() {
    return this.isPublic
      ? this.publicProfile?.full_name
      : this.user && `${this.user.first_name} ${this.user.last_name}`;
  }

  get location() {
    return this.isPublic
      ? this.publicProfile?.contestant?.country_residence?.name
      : this.user &&
      this.user.contestant &&
      this.user.contestant.country_residence &&
      this.user.contestant.country_residence.name;
  }

  get memberTime() {
    return this.isPublic
      ? moment(this.publicProfile?.created_at).tz(this.timezone).format('MM/YYYY')
      : moment(this.user?.created_at).tz(this.timezone).format('MM/YYYY');
  }

  get skills() {
    return this.isPublic
      ? this.publicProfile?.contestant?.skills
      : this.user && this.user.contestant && this.user.contestant.skills;
  }

  get avatar() {
    return this.isPublic
      ? this.publicProfile?.avatar
      : this.user && this.user.avatar;
  }

  detectScreenSizeSkills({ mdOnly, smAndDown }: Breakpoint): number {
    return mdOnly ? 2 : smAndDown ? 4 : 12;
  }
}
